module.exports = __webpack_public_path__ + "static/media/earth-gonna-die.68d9550f.mov";